import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Check: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
  </SvgIcon>
)
